'use strict';
/**
 * Resource Helper (wdResourceHelper.js).
 * Resource Helper.
 *
 * @author rsweeney@webduct.com <rsweeney@webduct.com>
 * @copyright 2018 Webduct Systems Inc.
 *
 * @version
 * 1.0.0 LIBENV-1 Initialize environment library
 *
 */
angular.module('wd.helper.resources', [])
    .factory('wdResourceHelper',
        function () {

            // Resources
            return new WebductResources();

        });
// EOF